import React from "react";
import styles from "./styles.module.scss"; // Assuming you are using styles.module.scss
import { useIsMobile } from "src/hooks/useIsMobile";

interface MainImageBackgroundProps {
  mobileImageSrc: string;
  desktopImageSrc: string;
}

const MainImageBackground: React.FC<MainImageBackgroundProps> = ({
  mobileImageSrc,
  desktopImageSrc,
}) => {
  const isMobile = useIsMobile();
  return (
    <div>
      {isMobile ? (
        <img
          src={mobileImageSrc}
          className={styles.mobileImage}
          alt="Mobile Background"
        />
      ) : (
        <div className={styles.mainImageWrapper}>
          <img
            src={desktopImageSrc}
            className={styles.cardImage}
            alt="Desktop Background"
          />
        </div>
      )}
    </div>
  );
};

export default MainImageBackground;
